import {useSelector} from 'react-redux';

/**
 * Default TopBar height in pixels.
 * This should match the height of the TopBar/HomeTop component.
 */
const DEFAULT_TOPBAR_HEIGHT = 126;

/**
 * Hook to get the total offset needed to position content below
 * the fixed TopBar and any active global banners.
 * 
 * Use this instead of hardcoded padding-top values like pt={'120px'}
 * to ensure content properly accounts for global banners.
 * 
 * @param baseOffset - Optional custom base offset (defaults to 120px TopBar height)
 * @returns The total offset in pixels as a string (e.g., "175px")
 */
export function useTopBarOffset(baseOffset: number = DEFAULT_TOPBAR_HEIGHT): string {
  const bannerHeight = useSelector((state: any) => state.globalBanner?.bannerHeight ?? 0);
  return `${baseOffset + bannerHeight}px`;
}

/**
 * Hook to get just the banner height for manual calculations.
 * 
 * @returns The current banner height in pixels (0 if no banner)
 */
export function useBannerHeight(): number {
  return useSelector((state: any) => state.globalBanner?.bannerHeight ?? 0);
}

export default useTopBarOffset;
